import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';

const SmartSchankPluField = ({ object, ...props }) => {
  const smartSchankPlu = object?.smartSchankPlu || null;
  return (
    <AvGroup className="form-label-group">
      <AvInput
        id={object?.id}
        type="text"
        name="smartSchankPlu"
        placeholder="Dirmeier SmartSchank PLU"
        value={smartSchankPlu}
        // hint: validate gets the value from valueParser and validates it then
        validate={{ number: true }}
        valueParser={(value) => (value ? parseInt(value) : 0)}
        {...props}
      />
      <Label for={object?.id}>Dirmeier SmartSchank PLU</Label>
    </AvGroup>
  );
};

SmartSchankPluField.propTypes = {
  object: PropTypes.object,
};

export default SmartSchankPluField;
